import { IconButton, Paper, Typography } from "@material-ui/core";
import React, { useState } from "react";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(theme=>({
  primary: {
    color: theme.palette.primary.main
  }
}))

const Collapseable = ({i=0,name,desc,...props}) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles()
  return (
    <Paper className="shadow my-3 rounded-corners">
      <div className="py-3 px-4" style={{cursor: `pointer`}} onClick={() => setOpen((o) => !o)}>
        <div className="d-flex justify-content-center align-items-center">
          <Typography variant="h5" className={open && classes.primary} style={{flexGrow: 1,fontWeight: `600`}}>{i+1}) {props[name]}</Typography>
          <div >
            <IconButton className={open && classes.primary}>
              {open ? <ExpandLess color="inherit" /> : <ExpandMore color="inherit" />}
            </IconButton>
          </div>
        </div>
      </div>
        <Collapse in={open}>
          <Typography dangerouslySetInnerHTML={{__html: props[desc]}} variant="body1" className="p-4"/>
        </Collapse>
    </Paper>
  );
};

export default Collapseable;